import { SweetAlertOptions } from "sweetalert2";
import { CustomToast, ErrorToast, SuccessToast } from "../common/toasts/toasts";
import getTheme from "../styles/themes/getTheme";
import useQuery from "./useQuery";

type ToastType = "info" | "error" | "success";

export const showToast = (type: ToastType, options: SweetAlertOptions) => {
  const { colors } = getTheme(useQuery().get("theme") || "");

  switch (type) {
    case "info":
      CustomToast.fire({
        ...options,
        color: options.color || colors.primary,
      });
      break;
    case "error":
      ErrorToast.fire(options);
      break;
    case "success":
      SuccessToast.fire(options);
      break;
    default:
      break;
  }
};
